import { useState, useEffect } from 'react';

function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(363599); // 100 часов 59 минут 59 секунд в секундах

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 0) {
          // Когда время истекает, перезапускаем с начала
          return 363599; // 100h:59m:59s
        }
        return prevTime - 1;
      });
    }, 1000);

    // Очистка интервала при размонтировании компонента
    return () => clearInterval(interval);
  }, []);

  // Форматирование времени в чч:мм:сс
  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    return `${hours}h : ${minutes.toString().padStart(2, '0')}m : ${seconds.toString().padStart(2, '0')}s`;
  };

  return (
    <div>
      <p >
        {formatTime(timeLeft)}
      </p>

    </div>
  );
}

export default CountdownTimer;